import { Step } from '../../../../../views/alerts/PendingOrderAlertScreen';
import { BackendErrorCode, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  steps: {
    [Step.OrderPreview]: {
      titles: {
        asap: '¡Nuevo pedido de {{method}}!',
        scheduled: '¡Pedido programado de {{method}}!',
        on_site: '¡Nuevo pedido en mesa!',
        // Table orders are ASAP; this is for room-service orders scheduled before the rename.
        on_site_scheduled: '¡Pedido programado en mesa!',
      },
      labels: {
        today: 'hoy',
        time_remaining_to_accept: 'restante para aceptar',
      },
      time_tag: {
        [OrderMethod.Pickup]: {
          asap: '🕓 Recogida en {{time}}',
          scheduled: '🕓 Recogida {{day}} a las {{time}}',
          scheduled_today: '🕓 Recogida hoy a las {{time}}',
        },
        [OrderMethod.Delivery]: {
          asap: '🕓 Entrega en {{time}}',
          scheduled: '🕓 Entrega {{day}} a las {{time}}',
          scheduled_today: '🕓 Entrega hoy a las {{time}}',
        },
        [OrderMethod.OnSite]: {
          // No 🕓: the screen draws the design's clock icon for table orders.
          asap: 'Servir en {{from}}–{{to}} min',
          scheduled: 'Servir {{day}} a las {{time}}',
          scheduled_today: 'Servir hoy a las {{time}}',
        },
      },
      time_tag_estimated: {
        asap: '🕓 Estimación de recogida: {{time}}',
        scheduled: '🕓 Estimación de recogida: {{day}} a las {{time}}',
      },
      buttons: {
        confirm_order: 'Confirmar pedido',
        cancel_order: 'Cancelar pedido',
      },
      feedback: {
        rough_estimate_warning:
          'Esta es solo una estimación aproximada. Recibirás el tiempo de preparación real una vez que se asigne un conductor y se confirme la hora de entrega. En ese momento, tu ticket se imprimirá automáticamente.',
      },
    },
    [Step.OrderConfirmation]: {
      title: 'Tiempo de preparación',
      labels: {
        today: 'hoy',
        order_time: {
          [OrderMethod.Delivery]: {
            asap: 'Entrega en',
            scheduled: 'Entrega el',
            scheduled_today: 'Entrega',
          },
          [OrderMethod.Pickup]: {
            asap: 'Recogida en',
            scheduled: 'Recogida el',
            scheduled_today: 'Recogida',
          },
          [OrderMethod.OnSite]: {
            asap: 'Servir en',
            scheduled: 'Servir el',
            scheduled_today: 'Servir',
          },
        },
        can_you_make_it: '¿Puedes hacerlo?',
        we_also_send_this_update_to_the_customer: 'También enviamos esta actualización al cliente',
      },
      buttons: {
        yes_lets_go: '¡Sí, vamos!',
        no_change_time: 'No, cambiar hora',
        confirm: 'Confirmar',
      },
      toasts: {
        order_confirmed: {
          title: 'Pedido #{{number}} confirmado',
          body: '¡No prepares aún! Te avisaremos cuando se asigne un conductor.',
        },
        [BackendErrorCode.NoDeliveryQuotesAvailable]:
          'Lamentablemente, la entrega debe cancelarse porque el conductor no está disponible. Haz clic en los tres puntos en la esquina superior derecha para cancelar el pedido y reembolsar el dinero al cliente',
        [BackendErrorCode.DeliveryProviderException]:
          'Lamentablemente, la entrega debe cancelarse porque el conductor no está disponible. Haz clic en los tres puntos en la esquina superior derecha para cancelar el pedido y reembolsar el dinero al cliente',
        [BackendErrorCode.DeliveryDispatchRetrying]:
          'Pedido aceptado, pero aún no hay conductor asignado. Seguimos intentándolo durante 15 minutos y te avisaremos si no se encuentra ninguno.',
      },
    },
  },
  error_messages: {
    something_went_wrong: 'Algo salió mal, inténtalo de nuevo',
  },
};
